import currency from "currency.js";

export const formatCurrency = (amount: number) =>
  currency(amount, {
    decimal: ",",
    separator: ".",
    symbol: "€",
    pattern: `! #`,
  }).format();
